import React from 'react';
import StateMessage from '../StateMessage/StateMessage';

const ConnectionError = ({ label, onClick }) => (
  <StateMessage
    illustration={'lineal_sistema_error'}
    title={'¡Lo sentimos!'}
    subtitle={label}
    button={{
      text: 'Reintentar',
      variant: 'secondary',
      onClick,
    }}
  />
);

export default ConnectionError;
